/**
 * usePlattformSettingsStand — zeichnet die Komponente neu, sobald neue
 * Plattform-Einstellungen angewendet wurden (18.10.2026).
 *
 * @module hooks/usePlattformSettingsStand
 */

import { useSyncExternalStore } from 'react';
import { abonnierePlattformSettings, plattformSettingsStand } from '../config/constants.js';

/** @returns Stand-Zähler (ändert sich bei jedem neuen Einstellungs-Satz) */
export function usePlattformSettingsStand(): number {
  return useSyncExternalStore(abonnierePlattformSettings, plattformSettingsStand, plattformSettingsStand);
}
